import { request, requestAnonymous, requestDynamicContent } from './request';
import { State } from '@telstra-connect/login';
import { IInputQuery } from '../common';
import { RequestHeaders } from './request-base';

export interface IGetProps {
    url: string;
    state: State.ISignInState;
    queryString?: IInputQuery;
    customHeaders?: RequestHeaders;
    processResponse?: <R>(response: Response) => Promise<R>;
    withResponseHeaders?: boolean;
}

export interface IGetAnonymousProps {
    url: string;
    queryString?: IInputQuery;
    processResponse?: <R>(response: Response) => Promise<R>;
}

export interface IGetDynamicContentProps {
    url: string;
    hostUrl: string;
    processResponse?: <R>(response: Response) => Promise<R>;
}

export const get = <TResult>(props: IGetProps) =>
    request<TResult>({
        ...props,
        method: 'GET',
    });

export const getAnonymous = <TResult>(props: IGetAnonymousProps) =>
    requestAnonymous<TResult>({
        ...props,
        method: 'GET',
    });

export const getDynamicContent = <TResult>(props: IGetDynamicContentProps) =>
    requestDynamicContent<TResult>({
        ...props,
        method: 'GET',
    });
